import React from 'react';
import IdChooser from './IdChooser';
import ComingSoon from './images/ComingSoon.jpeg';

export default (props) => {
  return <>{props?.error?.errorcode!=9678&&<IdChooser/>}
  {props?.error?.errorcode==9678&&<AwSomeErrorPage/>}
  </>; 
  
};

const AwSomeErrorPage=()=>{

  return <div style={{margin:'auto'}}>
    <div style={{position:'absolute',zIndex:3,fontSize:'60px',color:'white',width:'100%',textAlign:'center',marginTop:200,textShadow:' -1px 1px 10px rgba(0, 0, 0, 0.75)'}}>Coming soon</div>
    <div style={{position:'absolute'}}>
      <img src={ComingSoon} style={{position:'absolute',width:'100vw',height:'100vh',objectFit:'cover',zIndex:1}}  /></div></div>;

};
